module.exports = __webpack_public_path__ + "img/savings.2f2112e6.svg";